// Every field in these forms renders its error through MUI's `error` prop, which
// stamps `Mui-error` on the control — so the first match in DOM order is the first
// field the user needs to fix. `data-field-error` is an escape hatch for anything
// rendered outside MUI.
const ERROR_SELECTOR = '.Mui-error, [data-field-error="true"]';
const FIELD_SELECTOR = '.MuiFormControl-root, .MuiTextField-root';

/**
 * Brings the first invalid field into view after a failed submit, so required
 * fields further down the page are not missed.
 *
 * Deferred to the next tick because React has not painted the freshly set errors
 * at the moment the submit handler runs.
 */
export const scrollToFirstError = () => {
    if (typeof document === 'undefined') return;

    setTimeout(() => {
        const errorNode = document.querySelector(ERROR_SELECTOR);
        if (!errorNode) return;

        const field = errorNode.closest(FIELD_SELECTOR) || errorNode;
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // focus without a second jump, so it does not fight the smooth scroll
        const focusable = field.querySelector(
            'input:not([type="hidden"]), textarea, [contenteditable="true"]'
        );
        if (focusable) {
            focusable.focus({ preventScroll: true });
        }
    }, 0);
};

export default scrollToFirstError;
